// eslint-disable-next-line jira/import-whitelist
import memoizeOne from 'memoize-one';
import { createResource } from '@atlassian/react-resource-router';
import { getNavigationUiState } from './services/get-data/index.tsx';

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { NAVIGATION_UI_STORAGE_KEY } from './constants';

const getNavigationUiStateMemoized = memoizeOne((atlassianAccountId) =>
	getNavigationUiState({ tenantContext: { atlassianAccountId } }),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const navigationUiStateResource = createResource<any>({
	type: 'RESOURCE_TYPE_NAVIGATION_UI',
	getKey: () => 'state',
	getData: async (_, { tenantContext: { atlassianAccountId } }) =>
		getNavigationUiStateMemoized(atlassianAccountId),
	maxAge: Infinity,
});
